import React from "react";
import { Location } from "history";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, match } from "react-router-dom";
import { ReactComponent as AdminSVG } from "go-core/images/svg/navigation/admin.svg";
import { ReactComponent as DashboardSVG } from "go-core/images/svg/navigation/dashboard.svg";
import { ReactComponent as HelpSVG } from "go-core/images/svg/navigation/help.svg";
import { ReactComponent as PartnerSVG } from "../../../images/svg/partner.svg";
import { UserRole } from "../../../services/Api/types";
import { hasRole } from "../../../services/users/selectors";
import { UserState } from "../../../services/users/types";

interface NavigationProps {
	user: UserState;
	isAdmin?: boolean;
}

const NavigationUserMenu = (props: NavigationProps) => {
	const { t } = useTranslation();
	const hasPosnetRole = !!props.user?.roles?.includes(UserRole.POSNET);
	const hasOfficeRole = !!props.user?.roles?.includes(UserRole.OFFICE);
	const hasSupportRole = !!props.user?.roles?.includes(UserRole.SUPPORT);
	const hasItSupportRole = !!props.user?.roles?.includes(UserRole.IT_SUPPORT);
	const hasSaleRole = !!props.user?.roles?.includes(UserRole.SALE);
	const hasSaleTlRole = useSelector(hasRole(UserRole.SALE_TL));
	const hasCsTlRole = useSelector(hasRole(UserRole.CS_TL));

	return (
		<Nav variant="pills" className="flex-column navigation-user-menu">
			<Nav.Item>
				<Nav.Link
					as={NavLink}
					to="/dashboard"
					isActive={(_: match | null, location: Location) => {
						return location.pathname === "/" || location.pathname === "/dashboard";
					}}
				>
					<div className="nav-link-svg">
						<DashboardSVG />
					</div>
					<span>{t("lib:common.word.locations")}</span>
				</Nav.Link>
			</Nav.Item>
			{
				<Nav.Item>
					<Nav.Link as={NavLink} to={`/partnership`}>
						<div className="nav-link-svg">
							<PartnerSVG />
						</div>
						<span>{t("components.navigation.partner_panel.title")}</span>
					</Nav.Link>
				</Nav.Item>
			}
			{(props.user.admin || hasSupportRole || hasOfficeRole || hasSaleRole) && (
				<Nav.Item>
					<Nav.Link as={NavLink} to="/support">
						<div className="nav-link-svg">
							<HelpSVG />
						</div>
						<span>{t("components.navigation.support.title")}</span>
					</Nav.Link>
				</Nav.Item>
			)}
			{(props.user.admin || hasPosnetRole || hasOfficeRole || hasItSupportRole || hasSupportRole) && (
				<>
					<div className="divider" />
					<Nav.Item>
						<Nav.Link
							as={NavLink}
							to="/admin"
							isActive={(match, location) => {
								if (!match) return false;
								if (
									location.pathname.startsWith("/admin/reports") ||
									location.pathname.startsWith("/admin/it")
								) {
									return false;
								}
								return location.pathname.startsWith("/admin");
							}}
						>
							<div className="nav-link-svg">
								<AdminSVG />
							</div>
							<span>{t("components.navigation.admin.title")}</span>
						</Nav.Link>
					</Nav.Item>
					{(props.user.admin || hasOfficeRole || hasItSupportRole || hasCsTlRole || hasSaleTlRole) && (
						<Nav.Item>
							<Nav.Link as={NavLink} to="/admin/reports">
								<div className="nav-link-svg">
									<AdminSVG />
								</div>
								<span>Admin - Raporty</span>
							</Nav.Link>
						</Nav.Item>
					)}
				</>
			)}
		</Nav>
	);
};

export default NavigationUserMenu;
